import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import ModalContainer from 'components/shared/modal/modal_container';
import * as actions from 'actions/assign';
import { getAssignableIdentity } from 'actions/assign/helpers';
import StepsNavigator from './StepsNavigator';
import * as Views from './views';

class Container extends PureComponent {
  componentDidMount() {
    getAssignableIdentity()
      .then(this.props.toggleAssignableItem)
      .catch(() => {});
  }

  renderActiveStep() {
    const views = {
      CONTENT: <Views.Content />,
      ASSIGNEES: <Views.Assignees />,
      SCHEDULING: <Views.Scheduling timeZones={this.props.timeZones} />,
      REVIEW: <Views.Review />,
    };
    return views[this.props.activeStep];
  }

  get stepTitle() {
    const titles = {
      CONTENT: 'What are you assigning?',
      ASSIGNEES: 'Who should be assigned?',
      SCHEDULING: 'When is this content due?',
      REVIEW: 'Ready to assign?',
    };
    return titles[this.props.activeStep];
  }

  render() {
    const { toggleContainer, activeStep } = this.props;
    return (
      <ModalContainer
        className="AssignModal-background Modal-background"
        onEscape={toggleContainer}
      >
        <div
          className="AssignModal-container"
          data-current={activeStep.toLowerCase()}
        >
          <div
            role="button"
            tabIndex={0}
            aria-label={t('common.close')}
            className="AssignModal-closeButton"
            onClick={toggleContainer}
            onKeyDown={e => e.key === 'Enter' && toggleContainer()}
          >
            <Icon name="error" />
          </div>
          <div className="AssignModal-main">
            <h1 className="AssignModal-title">{this.stepTitle}</h1>
            {this.renderActiveStep()}
          </div>
          <div className="AssignModal-side">
            <StepsNavigator toggleContainer={toggleContainer} />
          </div>
        </div>
      </ModalContainer>
    );
  }
}

const mapStateToProps = state => ({
  activeStep: state.activeStep,
});

const mapDispatchToProps = {
  toggleAssignableItem: actions.toggleAssignableItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
